// extracted by mini-css-extract-plugin
export default {"tapImage":"mainBlock_tapImage__Af7hx"};